import React, { memo } from 'react'

import SignupForm from './SignupForm'
import PageTitle from '../shared/pageTitle/PageTitle'

const Signup = ({
  signupProfile,
  dispatchAction,
  onSignupSubmit,
  onSocialMediaLogin,
  t
}) => {
  const pageTitle = t('sign-up.sign-up')
  return (
    <>
      <PageTitle title={pageTitle} />
      <SignupForm
        signupProfile={signupProfile}
        onFormSubmit={onSignupSubmit}
        dispatchAction={dispatchAction}
        onSocialMediaLogin={onSocialMediaLogin}
        t={t}
      />
    </>
  )
}

export default memo(Signup)
